import md5 from 'js-md5';

//随机数字典
const randomDic = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*-_=+/.'.split('');
//设备指纹key
const fingerprintKey = 'ctsso-device-fingerprint';

export default {
    // 获取url请求参数
    getRequest: () => {
        //获取url中"?"符后的字串
        let url = location.search;
        let theRequest = {};
        if (url.indexOf("?") !== -1) {
            let str = url.substr(1);
            let strs = str.split("&");
            for (let i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
            }
        }
        return theRequest;
    },
    // 获取设备指纹
    getDeviceFingerprint: () => {
        let fingerprint = localStorage.getItem(fingerprintKey);
        if (fingerprint !== undefined && fingerprint !== null && fingerprint.length > 0) {
            return fingerprint;
        }
        // 如果获取不到本地存储的指纹，则是个新设备，生成一个新指纹并存储
        let randoms = [];
        for (let i = 0; i < 30; i++) {
            randoms.push(randomDic[Math.round(Math.random() * randomDic.length - 1)]);
        }
        let fingerprintStr = navigator.userAgent + '_' + new Date().getTime() + '_' + randoms.join('');
        fingerprint = md5(fingerprintStr);
        localStorage.setItem(fingerprintKey, fingerprint);
        return fingerprint;
    },
    /**
     * 格式化时间戳
     * @param time 时间戳
     * @param format 字符串模板 yyyy-MM-dd HH:mm:ss
     * @returns {*} 时间字符串
     */
    formatTimestamp: (time, format) => {
        if (("" + time).length === 10) {
            time = time * 1000;
        }
        let t = new Date(time);
        let tf = (i) => (i < 10 ? '0' : '') + i;
        return format.replace(/yyyy|MM|dd|HH|mm|ss/g, (a) => {
            switch (a) {
                case 'yyyy':
                    return tf(t.getFullYear());
                case 'MM':
                    return tf(t.getMonth() + 1);
                case 'mm':
                    return tf(t.getMinutes());
                case 'dd':
                    return tf(t.getDate());
                case 'HH':
                    return tf(t.getHours());
                case 'ss':
                    return tf(t.getSeconds());
            }
        })
    },
}